<template>
    <div class="xx-upload" :class="{'is-disabled': disabled}">
        <Upload
            ref="upload"
            :action="action"
            :data="params"
            :withCredentials="withCredentials"
            :name="name"
            :headers="headers"
            :httpRequest="httpRequest"
            :multiple="multiple"
            :limit="_limit"
            :drag="drag"
            :listType="listType"
            :accept="accept"
            :disabled="_disabled"
            :showFileList="showFileList"
            :fileList="fileList"
            :on-exceed="_onExceed"
            :before-upload="_beforeUpload"
            :on-progress="_onProgress"
            :on-success="_onSuccess"
            :on-error="_onError"
            :on-change="_onChange"
            :on-preview="_onPreview"
            :before-remove="_beforeRemove"
            :on-remove="_onRemove"
            :showFileName="showFileName"
        >
            <template v-if="listType !== 'picture-card'">
                <slot>
                    <el-button
                        v-if="!drag"
                        :disabled="disabled"
                        type="primary"
                    >{{uploadText || '上传文件'}}</el-button>
                    <template v-else>
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                            将文件拖到此处，或
                            <em>点击上传</em>
                        </div>
                    </template>
                </slot>
            </template>
            <template v-if="listType === 'picture-card'">
                <slot>
                    <i class="el-icon-plus"></i>
                </slot>
            </template>
            <template v-if="$slots.trigger">
                <slot slot="trigger" name="trigger"></slot>
            </template>
            <template v-if="$slots.tip">
                <slot slot="tip" name="tip"></slot>
            </template>
        </Upload>
        <!-- preview -->
        <el-dialog v-if="preview" class="xx-upload-dialog" :visible="showImageViewer" :append-to-body="inDialog" width="0">
            <image-viewer
                v-if="preview && showImageViewer"
                v-show="true"
                :z-index="2000"
                :initial-index="imageIndex"
                :on-close="closeImageViewer"
                :url-list="previewImageList"
            />
        </el-dialog>
    </div>
</template>

<script>
import { linkTo } from '@lsfe/tools';
import Upload from '../../elementui/upload/src/index.vue';
// import { deepClone } from '@lsfe/tools';
import emitter from '../../utils/mixins/emitter';
import ImageViewer from '../image/src/image-viewer';
import { defaultAction, getFileUrl, getFileUrlCommon, getNameByUrl, getFileName, isImg } from '../XUpload/utils';

let prevOverflow = '';

export default {
    // 特殊版本upload 为了灰度实验
    name: 'XnUpload',
    components: {
        Upload,
        ImageViewer
    },
    mixins: [emitter],
    props: {
        paste: {
            type: Boolean,
            default: false,
        },
        value: {
            type: [String, Array],
        },
        /**
         * 单文件 or 多文件。单文件时，新上传第文件会覆盖当前文件。
         */
        multiple: {
            type: Boolean,
            default: true
        },
        /**
         * 上传按钮名称
         */
        uploadText: {
            type: String
        },
        bucketName: {
            type: String
        },
        /**
         * 文件大小限制，单位：M
         */
        fileSize: {
            type: Number,
            default: 10
        },
        /**
         * 是否支持文件预览
         */
        preview: {
            type: Boolean,
            default: true
        },
        onGetFileName: {
            type: Function,
            default: getFileName
        },
        onGetFileUrl: {
            type: Function
        },
        // el-upload 的属性
        beforeUpload: {
            type: Function,
            default: v => true
        },
        onSuccess: {
            type: Function,
        },
        onError: {
            type: Function,
        },
        onRemove: {
            type: Function,
        },
        onPreview: {
            type: Function,
        },
        onExceed: {
            type: Function,
        },
        showFileList: {
            type: Boolean,
            default: true
        },
        drag: {
            type: Boolean
        },
        listType: {
            type: String,
            default: 'text'
        },
        limit: {
            type: Number
        },
        accept: {
            type: String
        },
        disabled: {
            type: Boolean
        },
        data: {
            type: Object,
            default() {
                return {};
            }
        },
        headers: {
            type: Object
        },
        name: {
            type: String
        },
        withCredentials: {
            type: Boolean
        },
        action: {
            type: String,
            default: defaultAction
        },
        httpRequest: {
            type: Function
        },
        showFileName: {
            type: Boolean
        },
        // 是否是多图一起预览
        mulPreview: {
            type: Boolean,
            default: false
        },
        //  图片预览dilalog 是否在另外一个dialog里
        inDialog: {
            type: Boolean,
            default: false
        }
        // auto-upload
        // on-progress
        // on-change
        // before-remove
        // file-list
        // multiple
    },
    watch: {
        value(val) {
            this.handleValueChange(val);
        }
    },
    data() {
        return {
            params: {
                bucketName: '',
                fileName: ''
            },
            isValueTwoWayBinding: true,
            fileList: [],
            showImageViewer: false,
            imageIndex: -1,
            previewImageList: []
        };
    },
    inject: {
        elForm: {
            default: ''
        },
        elFormItem: {
            default: ''
        }
    },
    computed: {
        _limit() {
            return this.multiple ? this.limit : 999;
        },
        _disabled() {
            return this.disabled || (this.elForm || {}).disabled;
        },
    },
    created() {
        this.handleValueChange(this.value);
        this.handlePasteListener();
    },
    beforeDestroy() {
        this.handleParse && window.removeEventListener('paste', this.handleParse);
        window.xxUploadPaste--;
    },
    methods: {
        handlePasteListener() {
            if (!this.paste) {
                return;
            }
            if (!window.xxUploadPaste) {
                window.addEventListener('paste', this.handleParse);
                window.xxUploadPaste = 1;
            } else {
                window.xxUploadPaste++;
                // eslint-disable-next-line no-console

            }
        },
        handleParse(e) {
            if (window.xxUploadPaste > 1) {
                console.error('本页面存在多个xx-upload开启paste属性，请检查代码');
                return;
            }
            if (e.clipboardData && e.clipboardData.items[0] && e.clipboardData.items[0].type && e.clipboardData.items[0].type.indexOf('image') > -1) {
                const file = e.clipboardData.items[0].getAsFile();
                this.$refs.upload.$refs['upload-inner'].uploadFiles([file]);
            }
        },
        handleValueChange(value) {
            if (!value || !value.length) {
                this.fileList = [];
                return;
            }
            if (!this.isValueTwoWayBinding) return;
            let list = typeof value === 'string' ? [value] : value;
            this.fileList = list.map(url => ({
                url,
                name: getNameByUrl(url)
            }));
        },
        _onPreview(file) {
            const {mulPreview} = this;
            // 图片墙并且要左右移动查看图片
            const isMul = mulPreview && this.listType === 'picture-card';
            this.onPreview && this.onPreview(file);
            if (!this.preview) return;
            let url = file.raw ? file.raw.$url : file.url;
            if (isImg(url)) {
                // prevent body scroll
                prevOverflow = document.body.style.overflow;
                document.body.style.overflow = 'hidden';
                const showImageList = this._getImageList();
                const imgIndex = showImageList.indexOf(url);
                this.showImageViewer = true;
                this.imageIndex = isMul ? imgIndex : 0;
                this.previewImageList = isMul ? [...showImageList] : [url];
            } else {
                linkTo(url, {}, true);
            }
        },
        _getImageList() {
            // 获取是图片的fileList
            return (this.fileList || []).map(v => {
                if((v.url || '').startsWith('blob:')) {
                    const response = v.response || {};
                    return (response.data || {}).url || '';
                }
                return v.url;
            }).filter(v => {
                return isImg(v);
            });
        },
        closeImageViewer() {
            document.body.style.overflow = prevOverflow;
            this.showImageViewer = false;
        },
        _beforeRemove(file, fileList) { },
        _onRemove(file, fileList) {
            this.onRemove && this.onRemove(file, fileList);
            this.emitValue(fileList);
        },
        _onExceed(files, fileList) {
            this.onExceed && this.onExceed(files, fileList);
            this.$message.error(`上传最大数量不能超过 ${this.limit} 张`);
            // this.$message.error(`最多允许${this.limit}个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        _onChange(file, fileList) {
            this.isValueTwoWayBinding = false; // 当触发第一次上传后，不响应 value 变化
        },
        _onProgress(event, file, fileList) { },
        _beforeUpload(file) {
            const fileName = this.onGetFileName(file);
            // 设置接口参数
            Object.keys(this.params).forEach(k => {
                delete this.params[k];
            });
            this.params.fileName = fileName;
            this.params.bucketName = this.bucketName;
            Object.keys(this.data).forEach(k => {
                this.params[k] = this.data[k];
            });
            // 添加文件信息
            file.$fileName = fileName;
            file.$bucketName = this.bucketName;
            file.$action = this.action;

            const result = this.beforeUpload(file);
            const isOverSize = file.size / 1024 / 1024 > this.fileSize;
            if (isOverSize) {
                this.$message.error(`上传文件大小不能超过${this.fileSize}MB!`);
            }
            // beforeUpload结果是true并且没超过大小
            return result && !isOverSize;
        },
        _onSuccess(res, file, fileList) {
            if (res && +res.code === 0) {
                // file url function
                const { $action } = file.raw;
                let getFileUrlFn = getFileUrl;
                if ($action !== defaultAction) {
                    getFileUrlFn = this.onGetFileUrl || getFileUrlCommon;
                }
                // get file url
                try {
                    const url = getFileUrlFn(res, file, fileList);
                    if (url) {
                        file.raw.$url = url;
                        file.name = file.raw.$fileName;
                        this.fileList = this.multiple ? fileList : [file];
                        this.onSuccess && this.onSuccess(res, file, fileList);
                        this.emitValue(this.fileList);
                    } else {
                        this.fileList = [...this.fileList]; // 去掉文件列表中刚刚添加的文件
                        this._onError(new Error('获取文件url失败'), file, this.fileList);
                    }
                } catch (error) {
                    this.fileList = [...this.fileList]; // 去掉文件列表中刚刚添加的文件
                    this._onError(error, file, this.fileList);
                }
            } else {
                this.fileList = [...this.fileList]; // 去掉文件列表中刚刚添加的文件
                this._onError(new Error(res.msg), file, this.fileList);
            }
        },
        _onError(err, file, fileList) {
            this.onError && this.onError(err, file, fileList);
            this.$message.error(err.toString() || '上传失败');
        },
        emitValue(fileList) {
            let list = fileList
                .filter(file => file.status === 'success');
            let inputList = list.map(file => {
                return file.raw ? file.raw.$url : file.url;
            });
            let input = this.multiple ? inputList : inputList[0] || '';
            let changeList = list.map(file => {
                if (!file.raw) return file;
                return {
                    url: file.raw.$url,
                    name: file.raw.$fileName
                };
            });
            let change = this.multiple ? changeList : changeList[0] || {};
            this.$emit('input', input);
            this.$emit('change', change);
            this.dispatch('ElFormItem', 'el.form.change', input);
        }
    }
};
</script>
